// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import ElementUI from 'element-ui';
//富文本
//import './ueditor/ueditor.config.js'
//import './ueditor/ueditor.all.min.js'
//import './ueditor/lang/zh-cn/zh-cn.js'
//import './ueditor/ueditor.parse.min.js'

import './ueditor/ueditor.config.js'
import './ueditor/ueditor.all.js'
import './ueditor/lang/zh-cn/zh-cn.js'
import './ueditor/ueditor.parse.js'

// import '../static/ueditor/ueditor.config.js'
// import '../static/ueditor/ueditor.all.js'
// import '../static/ueditor/lang/zh-cn/zh-cn.js'
// import '../static/ueditor/ueditor.parse.js'


Vue.use(ElementUI);
//引入store
import store from './store/index'
//全局混合
import mixins from './js/mixins'
Vue.mixin(mixins)
//公共组件
require("./components/globle");
require("./js/common.js");

import Print from 'vue-print-nb'
Vue.use(Print); //注册

import vuePictureViewer from './components/lib/index.js'
Vue.use(vuePictureViewer)
Vue.config.productionTip = false
/* eslint-disable no-new */


// Bus组件传值
Vue.prototype.Bus = new Vue();


new Vue({
	el: '#app',
	store,
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js